import { render, staticRenderFns } from "./HistoricoView.vue?vue&type=template&id=0b91046a"
import script from "./HistoricoView.vue?vue&type=script&lang=js"
export * from "./HistoricoView.vue?vue&type=script&lang=js"
import style0 from "./HistoricoView.vue?vue&type=style&index=0&id=0b91046a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports